const composeEmail = (email) => {
  window.open(`mailto:${email}`);
};

export default composeEmail;
